import { makeAutoObservable, observable } from "mobx"

class ExportSchemesDialogStore {

  val = observable.set<string>()
  constructor(values: string[]) {
    this.val.replace(values)
    makeAutoObservable(this)
  }

  toggle(key: string, value?: boolean) {
    if (value === false || this.val.has(key)) {
      this.val.delete(key)
    } else {
      this.val.add(key)
    }
  }

}

export default ExportSchemesDialogStore